// Z91: customers.address (the old free-text column) is retired -- its 95 values were archived and already exist as
// typed customer_addresses rows. Structured customer columns are the fallback for customers that have no typed
// address row (e.g. the 2026-10 address-book import writes the main address into these columns).
export interface CustomerAddressFields {
  address_line_1?: string | null
  address_line_2?: string | null
  city?: string | null
  postcode?: string | null
  country?: string | null
}

export function formatCustomerAddress(customer: CustomerAddressFields | null | undefined): string | null {
  if (!customer) return null
  const parts = [customer.address_line_1, customer.address_line_2, customer.city, customer.postcode, customer.country]
    .filter((p): p is string => !!p?.trim())
  return parts.length > 0 ? parts.join(', ') : null
}
